<template>
  <template v-if="isAdmin">
    <button
      type="button"
      class="px-3 py-1.5 text-xs rounded-md text-white bg-red-600 hover:bg-red-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors whitespace-nowrap"
      :disabled="isDeleting"
      title="Supprimer l'étiquette (admin)"
      @click="showConfirm = true"
    >
      <i v-if="isDeleting" class="fas fa-spinner fa-spin mr-1"></i>
      <i v-else class="fas fa-trash-alt mr-1"></i>

    </button>

    <ConfirmModal
      :show="showConfirm"
      title="Supprimer l'étiquette"
      :message="confirmMessage"
      confirm-text="Supprimer"
      :show-attention-icon="true"
      @confirm="confirmDelete"
      @cancel="showConfirm = false"
    />
  </template>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { adminEfpSoftDeleteEtiquette } from "@/api/adminEfp";
import { ConfirmModal } from "@/components";
import { useNotification } from "@/composables/useNotification";

const props = defineProps<{
  orderId: number;
  labelId: number;
  trackingNumber?: string;
}>();

const emit = defineEmits<{
  deleted: [];
}>();

const authStore = useAuthStore();
const { success, error } = useNotification();

const isAdmin = computed(() => authStore.isImpersonating);
const showConfirm = ref(false);
const isDeleting = ref(false);

const confirmMessage = computed(() => {
  const tracking = props.trackingNumber?.trim();
  if (tracking) {
    return `Supprimer l'étiquette du colis (suivi : ${tracking}) ?\nCette action est irréversible côté vendeur.`;
  }
  return "Supprimer cette étiquette ?\nCette action est irréversible côté vendeur.";
});

const confirmDelete = async () => {
  showConfirm.value = false;
  if (!props.orderId || !props.labelId) return;

  isDeleting.value = true;
  try {
    const result = await adminEfpSoftDeleteEtiquette(
      props.orderId,
      props.labelId,
    );
    if (!result.ok) {
      throw new Error(result.error || "Erreur lors de la suppression");
    }
    success("Étiquette supprimée");
    window.dispatchEvent(new CustomEvent("orderLabelsChanged"));
    emit("deleted");
  } catch (e) {
    error(
      e instanceof Error ? e.message : "Erreur lors de la suppression",
    );
  } finally {
    isDeleting.value = false;
  }
};
</script>
